module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loading) ? [_c('div', {
    staticClass: "my-overlay",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), (!_vm.show_error_dialog) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('h4', [_vm._v("Payment")]), _vm._v(" "), _c('div', {
    staticClass: "close-icon",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/remove-icon.svg"),
      "width": "32"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "divider my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-2 heading"
  }, [_vm._v("Purchase")]), _vm._v(" "), _c('div', {
    staticClass: "con_container"
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Product purchase")]), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")((_vm.amount + _vm.fee))))])]), _vm._v(" "), _c('div', {
    staticClass: "divider my-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, [_vm._v("\n         Sellers have 21 days to ship your items or your order is automatically refunded.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-2 mt-3 heading"
  }, [_vm._v("Credit card")]), _vm._v(" "), _c('div', {
    staticClass: "card-inputs"
  }, [_c('card-number', {
    ref: "cardNumber",
    staticClass: "stripe-element card-number payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.number = $event.complete
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-box-bottom"
  }, [_c('card-expiry', {
    ref: "cardExpiry",
    staticClass: "stripe-element card-expiry payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.expiry = $event.complete
      }
    }
  }), _vm._v(" "), _c('card-cvc', {
    ref: "cardCvc",
    staticClass: "stripe-element card-cvc payment-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripe_publishable_key,
      "options": _vm.stripeOptions
    },
    on: {
      "change": function($event) {
        _vm.cvc = $event.complete
      }
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-cta",
    nativeOn: {
      "click": function($event) {
        _vm.sendPayment()
      }
    }
  }, [_vm._v("\n          Pay $" + _vm._s(_vm._f("formatNumber")((_vm.amount + _vm.fee))) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box__content"
  }), _vm._v(" "), _c('div', {
    staticClass: "divider my-4"
  }), _vm._v(" "), _vm._m(0)]) : _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_error_dialog),
      callback: function($$v) {
        _vm.show_error_dialog = $$v
      },
      expression: "show_error_dialog"
    }
  }, [_c('v-card', [(_vm.receiverAvatar) ? _c('v-card-media', {
    attrs: {
      "src": _vm.receiverAvatar,
      "height": "125px",
      "contain": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        You cannot send the payment\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.receiverName) + " did not connect to stripe yet\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__footer"
  }, [_c('div', {
    staticClass: "stripe-info"
  }, [_c('label', [_vm._v("Powered by")]), _vm._v(" "), _c('span', [_vm._v("stripe")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75888206","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentmodal.vue
// module id = 1783
// module chunks = 180